(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.innerWidth > 749) return;

    const DURATION = 280;

    document.querySelectorAll('.menu--accordion').forEach((accordion) => {
      const details = accordion.querySelector('.menu__details');
      const summary = details?.querySelector('summary');
      const content = details?.querySelector('.details-content');

      if (!details || !summary || !content) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        if (details.open) {
          accordion.style.minHeight = accordion.offsetHeight + 'px';

          const startHeight = content.scrollHeight;
          content.style.overflow = 'hidden';
          content.style.height = startHeight + 'px';
          content.getBoundingClientRect();

          content.style.transition = `height ${DURATION}ms ease, opacity ${DURATION}ms ease, transform ${DURATION}ms ease`;
          content.style.height = '0px';
          content.style.opacity = '0';
          content.style.transform = 'translateY(-8px)';

          content.addEventListener(
            'transitionend',
            (e) => {
              if (e.propertyName !== 'height') return;
              details.removeAttribute('open');
              content.style.cssText = '';
              accordion.style.minHeight = '';
            },
            { once: true }
          );
        } else {
          details.setAttribute('open', '');
          const targetHeight = content.scrollHeight;

          content.style.overflow = 'hidden';
          content.style.height = '0px';
          content.style.opacity = '0';
          content.style.transform = 'translateY(-8px)';
          content.getBoundingClientRect();

          content.style.transition = `height ${DURATION}ms ease, opacity ${DURATION}ms ease, transform ${DURATION}ms ease`;
          content.style.height = targetHeight + 'px';
          content.style.opacity = '1';
          content.style.transform = 'translateY(0)';

          content.addEventListener(
            'transitionend',
            (e) => {
              if (e.propertyName !== 'height') return;
              content.style.cssText = '';
            },
            { once: true }
          );
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
